<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import AppLayout from './components/layout/AppLayout.vue'
import SignatureScene from './components/sections/SignatureScene.vue'
import WorkIndex from './components/work/WorkIndex.vue'
import About from './components/sections/About.vue'
import Experience from './components/sections/Experience.vue'
import Contact from './components/sections/Contact.vue'

/*
  The case-study view is only reachable by opening a project, so it is
  code-split — the landing page never pays for it.
*/
const ProjectDetail = defineAsyncComponent(
  () => import('./components/work/ProjectDetail.vue')
)
</script>

<template>
  <div id="app">
    <AppLayout>
      <SignatureScene />
      <WorkIndex />
      <About />
      <Experience />
      <Contact />
    </AppLayout>

    <ProjectDetail />
  </div>
</template>
